<template>
    <the-list @down="loadAfter" @up="loadBefore" @current="updateCurrentOffset"
                :items="items" :loading="loading"
                v-slot:default="list">
        <v-card v-for="item in list.items" :key="item.offset"
            :data-list-item="item.offset"
            :class="{'current': currentOffset == item.offset}"
            class="mb-3"
            :style="cardStyle(item)">
            <v-card-text>
                <v-layout align-center>
                    <h2>{{ item.offset }}</h2>
                    <v-spacer />
                    <v-btn :to="{ name: 'demos', params: {
                            demo: 'UnlimitList'
                        },
                        query: {
                            prev: item.offset,
                            offset: item.offset,
                        }
                    }">
                        <v-icon class="mr-2">colorize</v-icon>
                        Kies
                    </v-btn>
                </v-layout>
            </v-card-text>
        </v-card>
    </the-list>
</template>

<script>
import TheList from './List'

export default {
    components: {
        TheList,
    },
    data () {
        let offset = this.$route.query.offset
        if (!offset && offset !== 0) {
            offset = Math.round(Math.random() * 1000)
        }

        return {
            loading: false,
            items: [],
            currentOffset: offset,
            topOffset: offset,
            bottomOffset: offset,
            maxItems: 200,
        }
    },
    computed: {
        prev () {
            return this.$route.query.prev
        },
    },
    methods: {
        async loadBefore () {
            const nw = await this.loader(this.topOffset, 'BEFORE')
            this.items = nw.concat(this.items).slice(0, this.maxItems)
            this.updateOffsets()
        },
        async loadFrom () {
            const nw = await this.loader(this.bottomOffset, 'FROM')
            this.items = this.items.concat(nw).slice(-this.maxItems)
            this.updateOffsets()
        },
        async loadAfter () {
            const nw = await this.loader(this.bottomOffset, 'AFTER')
            this.items = this.items.concat(nw).slice(-this.maxItems)
            this.updateOffsets()
        },
        updateOffsets () {
            if (!this.items.length) {
                this.bottomOffset = null
                this.topOffset = null
            } else {
                this.bottomOffset = this.items[this.items.length - 1].offset
                this.topOffset = this.items[0].offset
            }
        },
        updateCurrentOffset (offset) {
            this.currentOffset = offset

            if (`${this.$route.query.offset}` === `${this.currentOffset}`) {
                return
            }

            this.$router.replace({
                query: {
                    ...this.$route.query,
                    offset: this.currentOffset,
                },
            })
        },
        async loader (offset, rel) {
            const perChunk = 20

            this.loading = true
            // await new Promise((resolve) => setTimeout(resolve, (Math.random() * 200) + 50))

            const items = this.sliceOfData(offset, rel, perChunk)
            if (!items.length) {
                return []
            }

            this.loading = false

            return items
        },
        sliceOfData (offset, rel, perChunk) {
            rel = offset === null ? 'FROM' : rel
            offset = parseInt(offset) || 0

            const data = []
            if (rel === 'FROM') {
                for (let i = offset; i < offset + perChunk; i++) {
                    data.push({ offset: i })
                }
                return data
            }

            if (rel === 'AFTER') {
                for (let i = offset + 1; i <= offset + perChunk; i++) {
                    data.push({ offset: i })
                }
                return data
            }

            if (rel === 'BEFORE') {
                for (let i = offset - perChunk; i < offset; i++) {
                    data.push({ offset: i })
                }
                return data
            }
        },
        cardStyle (item) {
            const h = item.offset % 360
            const prevH = this.prev ? this.prev % 360 : h
            return `background-image: linear-gradient(to left, hsla(${h}, 50%, 50%, 1), hsla(${prevH}, 50%, 50%, 1));`
        },
    },
    async mounted () {
        await this.loadFrom()
        await this.loadBefore()
    },
}
</script>

<style scoped>
.current {
    border: 1px solid var(--v-accent-base);
    border-width: 0 1px;
}
</style>
